import React from 'react'
import styled from 'styled-components'
import Banner from '../../components/Banner'
import Title from '../../components/Title'
import Button from '../../components/Button'
import Hr from '../../components/Hr'
import Paragraph from '../../components/Paragraph'
import img1 from '../../assets/static/products_img1.jpg'
import img2 from '../../assets/static/products_img2.png'
import img3 from '../../assets/static/products_img3.png'
import img4 from '../../assets/static/products_img4.png'
import img5 from '../../assets/static/products_img5.png'
import img6 from '../../assets/static/products_img6.png'
import img7 from '../../assets/static/products_img7.png'
import img8 from '../../assets/static/products_img8.png'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
  
const About = () => {
  const { t } = useTranslation()
  return (
    <Main>
      <Banner title={t('products.hero.title')}>
        <>
          <Hr color="primary" />
          <Title size="small" color="white">
            {t('products.hero.desc')}
          </Title>
        </>
      </Banner>
      <Article2>
        <Title color="white" size="small">
          {t('products.heroTwo.title')}
        </Title>
      </Article2>
      <Article1 id="macetas">
        <div>
          <Img src={img1} alt="" />
        </div>
        <Content>
          <Title size="mid" color="primary">
            {t('products.products.0.title')}
          </Title>
          <LogoImg>
            <Logo src={img2} alt="" />
            <div>
              <Paragraph>
               {t('products.products.0.desc')}
              </Paragraph>
              <Paragraph>
                {t('products.products.0.descTwo')}
              </Paragraph>
            </div>
          </LogoImg>
        </Content>
      </Article1>
      <Article1 id="banos">
        <Content>
          <Title size="mid" color="primary">
            {t('products.products.1.title')}
          </Title>
          <LogoImg>
            <Logo src={img3} alt="" />
            <div>
              <Paragraph>
                {t('products.products.1.desc')}
              </Paragraph>
              <Paragraph>
                {t('products.products.1.descTwo')}
              </Paragraph>
            </div>
          </LogoImg>
          <Paragraph />
        </Content>
        <div>
          <Img src={img4} alt="" />
        </div>
      </Article1>
      <Article1 id="sena">
        <div>
          <Img src={img5} alt="" />
        </div>
        <Content>
          <Title size="mid" color="primary">
            {t('products.products.2.title')}
          </Title>
          <LogoImg>
            <div>
              <Paragraph>
                {t('products.products.2.desc')}
              </Paragraph>
              <Paragraph>
                {t('products.products.2.descTwo')}
              </Paragraph>
            </div>
          </LogoImg>
        </Content>
      </Article1>
      <Article1 id="tarimas">
        <Content>
          <Title size="mid" color="primary">
            {t('products.products.3.title')}
          </Title>
          <LogoImg>
            <Logo src={img6} alt="" />
            <div>
              <Paragraph>
                {t('products.products.3.desc')}
              </Paragraph>
              <Paragraph>
                {t('products.products.3.descTwo')}
              </Paragraph>
            </div>
          </LogoImg>
          <Paragraph />
        </Content>
        <div>
          <Img src={img7} alt="" />
        </div>
      </Article1>
      <Article1 id="contenedores">
        <div>
          <Img src={img8} alt="" />
        </div>
        <Content>
          <Title size="mid" color="primary">
            {t('products.products.4.title')}
          </Title>
          <LogoImg>
            <div>
              <Paragraph>
                {t('products.products.4.desc')}
              </Paragraph>
              <Paragraph>
                {t('products.products.4.descTwo')}
              </Paragraph>
            </div>
          </LogoImg>
        </Content>
      </Article1>
      <Article3>
        <Content2>
          <Title size="big" color="secondary">
            {t('products.banner.title')}
          </Title>
          <Title size="mid" color="black">
            {t('products.banner.desc')}
          </Title>
          <Link to="/contact">
            <Button>{t('products.banner.cta')}</Button>
          </Link>
        </Content2>
      </Article3>
    </Main>
  )
}

export default About

const Main = styled.main`
  background-color: #fff;
`

const Article1 = styled.article`
  display: flex;

  & > :nth-of-type(odd) {
    background-color: ${props => props.theme.grayLight};
    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const Article2 = styled.article`
  background-color: ${props => props.theme.bgWeb};
  padding: 50px 100px;
  text-align: center;
`

const Content = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 75px;
  @media (max-width: 768px) {
    align-items: center;
  }
`

const Content2 = styled.div`
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const Img = styled.img`
  width: 40vw;
  height: 100%;
  object-fit: cover;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const Article3 = styled.article`
  grid-column: 1/4;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 50px;
  background-color: ${props => props.theme.grayLight};
  text-align: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const Logo = styled.img`
  width: 200px;
  object-fit: contain;
  margin-right: 15px;
  @media (max-width: 768px) {
    text-align: center;
    margin-right: 0;
  }
`

const LogoImg = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`
